// extracted by mini-css-extract-plugin
module.exports = {"widget":"TextWidget_widget__3G9-j","suffix":"TextWidget_suffix__2xYUf","hidden":"TextWidget_hidden__3j3BS"};